import "./campaign.css";
import React from "react";
import { Route } from "react-router-dom";
import VestillionRoutes from "./vestillion/Routes";
import CorralRoutes from "./corral/Routes";

export default () => {
  return (
    <Route path="/campaigns">
      {[VestillionRoutes(), CorralRoutes()].flat(Infinity)}
    </Route>
  );
};
